import React, { useState } from "react"
import { useMutation, useQuery } from "react-query"
import { useMarina } from "src/contexts/MarinaContext"
import AddTaxModal from "src/main/MarinaTaxes/AddTaxModal"

import Button from "src/components/Button"
import DataTable from "src/components/DataTable"

import { deleteMarinaTax, getMarinaTaxes } from "src/api/Manage/Taxes"

import { useToast } from "src/hooks/use_toast"

export default function MarinaTaxesController() {
  const { marinaSlug } = useMarina()
  const showToast = useToast()
  const [addTaxModalOpen, setAddTaxModalOpen] = useState(false)

  const {
    data: marinaTaxesData,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ["marina", marinaSlug, "taxes"],
    queryFn: () => getMarinaTaxes(marinaSlug),
  })

  const { mutate: deleteTaxMutation } = useMutation({
    mutationKey: ["marina", marinaSlug, "deleteTax"],
    mutationFn: (taxId) => deleteMarinaTax(marinaSlug, taxId),
    onSuccess: ({ data: { taxTypeDisplay, name } }) => {
      showToast(`${taxTypeDisplay} "${name}" has been removed`, {
        type: "success",
      })
      refetch()
    },
    onError: (error) => {
      showToast(error.message, { type: "error" })
    },
  })

  const rowConfig = {
    actions: (tax) => createActions(tax),
  }

  const createActions = (tax) => {
    return [
      {
        action: "Delete Tax",
        onClick: () => handleDelete(tax),
      },
    ]
  }

  const handleDelete = (tax) => {
    const { id, name } = tax
    if (window.confirm(`Are you sure you want to delete the tax "${name}"?`)) {
      deleteTaxMutation(id)
    }
  }

  const colDefs = [
    {
      key: "name",
      header: "Name",
    },
    {
      key: "taxTypeDisplay",
      header: "Type of Tax",
    },
    {
      key: "rateDisplay",
      header: "Tax Rate",
    },
  ]

  const handleAddTaxClick = () => {
    setAddTaxModalOpen(true)
  }

  const handleCloseModal = () => {
    refetch()
    setAddTaxModalOpen(false)
  }

  return (
    <>
      <div className="my-4 flex items-center justify-between px-2">
        <h2 className="m-0 text-2xl font-bold">Manage Global Taxes</h2>
        <Button variant="primary" onClick={handleAddTaxClick}>
          Add Tax
        </Button>
      </div>
      <AddTaxModal isOpen={addTaxModalOpen} onClose={handleCloseModal} />
      <div className="grid min-h-[400px] p-2">
        <DataTable
          name="taxes"
          rowData={marinaTaxesData?.data}
          rowConfig={rowConfig}
          colDefs={colDefs}
          isLoading={isLoading}
          showBlankRows={isLoading}
          rowCount={2}
          fullHeight
          autoColumnWidth
        />
      </div>
      <div className="mt-4 px-2 text-sm text-gray-600">
        Taxes defined here will apply to <b>all products</b>. To disable a tax
        for a specific product, visit the product page.
      </div>
    </>
  )
}
